<template>
    <div class="plano_modal" v-if="visible">
        <b-card style="width:600px">
            <label> <h3>Edit Caddy</h3> </label>
            <b-container fluid>
                <b-row>
                    <b-col sm="4"> <label>Fixed:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="fixed"></b-form-checkbox> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Width:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="width"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="height"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content X:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentX"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content Y:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentY"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content Width:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentWidth"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentHeight"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Cover Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="coverHeight"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Top Pawl:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="topPawl"></NumberInput> </b-col>
                </b-row>

                <b-row>
                    <b-col sm="4"> <label>Label text:</label> </b-col>
                    <b-col sm="8"> <input v-model="labelText"/></b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Bottom Pawl:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="bottomPawl"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Pawl Interval:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="pawlInterval"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Left Adhesive:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="leftAdhesive"></b-form-checkbox> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Right Adhesive:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="rightAdhesive"></b-form-checkbox> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Bottom Adhesive:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="bottomAdhesive"></b-form-checkbox> </b-col>
                </b-row>
            </b-container>
            <b-button-toolbar>
                <b-button style="margin:5px;" variant="primary" @click="validate();">Ok</b-button>
                <b-button style="margin:5px;" @click="cancel();">Cancel</b-button>
            </b-button-toolbar>
        </b-card>
    </div>
</template>

<script>
import NumberInput from "../components/number-input";

let editBoardCaddyWidget;
window.editBoardCaddy = function editBoardCaddy(data, onValidate, onCancel) {
    editBoardCaddyWidget.fixed = data.fixed;
    editBoardCaddyWidget.width = data.width;
    editBoardCaddyWidget.height = data.height;
    editBoardCaddyWidget.contentX = data.contentX;
    editBoardCaddyWidget.contentY = data.contentY;
    editBoardCaddyWidget.contentWidth = data.contentWidth;
    editBoardCaddyWidget.contentHeight = data.contentHeight;
    editBoardCaddyWidget.coverHeight = data.coverHeight;
    editBoardCaddyWidget.topPawl = data.topPawl;
    editBoardCaddyWidget.bottomPawl = data.bottomPawl;
    editBoardCaddyWidget.pawlInterval = data.pawlInterval;
    editBoardCaddyWidget.leftAdhesive = data.leftAdhesive;
    editBoardCaddyWidget.rightAdhesive = data.rightAdhesive;
    editBoardCaddyWidget.bottomAdhesive = data.bottomAdhesive;
    editBoardCaddyWidget.labelText = data.labelText;
    editBoardCaddyWidget.visible = true;
    editBoardCaddyWidget.onValidate = onValidate;
    editBoardCaddyWidget.onCancel = onCancel;
};
export default {
    components: { NumberInput },
    data() {
        return {
            width: 0,
            height: 0,
            contentX: 0,
            contentY: 0,
            contentWidth: 0,
            contentHeight: 0,
            coverHeight: 0,
            topPawl: 0,
            bottomPawl: 0,
            pawlInterval: 0,
            leftAdhesive: false,
            rightAdhesive: false,
            bottomAdhesive: false,
            labelText: "",
            fixed: false,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    created() {
        editBoardCaddyWidget = this;
    },
    methods: {
        validate() {
            this.onValidate({
                width: parseFloat(this.width),
                height: parseFloat(this.height),
                contentX: parseFloat(this.contentX),
                contentY: parseFloat(this.contentY),
                contentWidth: parseFloat(this.contentWidth),
                contentHeight: parseFloat(this.contentHeight),
                coverHeight: parseFloat(this.coverHeight),
                topPawl: parseFloat(this.topPawl),
                bottomPawl: parseFloat(this.bottomPawl),
                pawlInterval: parseFloat(this.pawlInterval),
                labelText: this.labelText,
                leftAdhesive: this.leftAdhesive,
                rightAdhesive: this.rightAdhesive,
                bottomAdhesive: this.bottomAdhesive,
                fixed: this.fixed
            });
            this.visible = false;
        },
        cancel() {
            this.onCancel();
            this.visible = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// edit_board_caddy.vue?64fad3c2